import { default as __nuxt_component_0 } from "/opt/build/repo/components/Partials/Activity/Views/WalletHistory/Common/TableHeader.vue";
import { default as __nuxt_component_1 } from "/opt/build/repo/components/Partials/Activity/Views/WalletHistory/Withdrawal.vue";
import { default as __nuxt_component_2 } from "/opt/build/repo/components/Common/EmptyList.vue";
import { default as __nuxt_component_3 } from "/opt/build/repo/components/Common/Table/Wrapper.vue";
import { default as __nuxt_component_4 } from "/opt/build/repo/components/App/HocLoading.vue";
"use strict";
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "w-full h-full" };
const _hoisted_2 = {
  key: 0,
  class: "table"
};
import { Status } from "@injectivelabs/utils";
import { BridgeTransactionState } from "@injectivelabs/sdk-ui-ts";
export default /* @__PURE__ */ _defineComponent({
  __name: "Withdrawals",
  props: {
    status: {
      type: Object,
      default: () => new Status()
    },
    symbol: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const bridgeStore = useBridgeStore();
    const filteredTransactions = computed(() => {
      return bridgeStore.withdrawalTransactions.filter((transaction) => {
        const isCompletedTransaction = transaction.state === BridgeTransactionState.Completed;
        const isPartOfSearchFilter = !props.symbol || transaction.token.symbol.toLowerCase() === props.symbol.toLowerCase();
        return isPartOfSearchFilter && isCompletedTransaction;
      });
    });
    const sortedTransactions = computed(
      () => filteredTransactions.value.sort((a, b) => b.timestamp - a.timestamp)
    );
    return (_ctx, _cache) => {
      const _component_PartialsActivityViewsWalletHistoryCommonTableHeader = __nuxt_component_0;
      const _component_PartialsActivityViewsWalletHistoryWithdrawal = __nuxt_component_1;
      const _component_CommonEmptyList = __nuxt_component_2;
      const _component_CommonTableWrapper = __nuxt_component_3;
      const _component_AppHocLoading = __nuxt_component_4;
      return _openBlock(), _createBlock(_component_AppHocLoading, {
        class: "h-full",
        status: __props.status,
        "loader-class": __props.status.isLoading() ? "relative" : ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_CommonTableWrapper, { "break-md": "" }, {
              default: _withCtx(() => [
                _unref(filteredTransactions).length > 0 ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
                  _createVNode(_component_PartialsActivityViewsWalletHistoryCommonTableHeader),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedTransactions), (transaction, index) => {
                      return _openBlock(), _createBlock(_component_PartialsActivityViewsWalletHistoryWithdrawal, {
                        key: `withdrawal-${index}-${transaction.timestamp}`,
                        transaction
                      }, null, 8, ["transaction"]);
                    }), 128))
                  ])
                ])) : (_openBlock(), _createBlock(_component_CommonEmptyList, {
                  key: 1,
                  message: _ctx.$t("walletHistory.emptyWithdrawalTransactions"),
                  class: "pb-4 grow bg-gray-900"
                }, null, 8, ["message"]))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["status", "loader-class"]);
    };
  }
});
